module.exports = __webpack_public_path__ + "media/icons/document-file-f7d5c949.png";